import { jsxs as _jsxs } from "react/jsx-runtime";
import style from "./style.module.scss";
/**
 * Display a metric and its value with some basic styling.
 */
export default function Metric(props) {
    const { title, value, budget, color } = props;
    let budgetContent = null;
    if (budget && budget !== "") {
        budgetContent = _jsxs("span", { className: style["metric-budget"], children: [" / ", budget] });
    }
    return (_jsxs("div", { style: { color }, children: [title, _jsxs("div", { className: style["metric-value"], children: [value, budgetContent] })] }));
}
